<template>
<div class="mzl">
    <template>
        <div class="critical-density-params">
            <div>
                <div class="events-sub-title">
                    Определение критической полноты
                </div>
                Фактическая преобладающая порода:
                <span style="font-weight: bold;">{{
            criticalDensityParams.species ? criticalDensityParams.species : "—"
          }}</span>
            </div>
            <div>ОЗУ по данным ТО: <span v-if="taxData" style='font-weight: bold;'>{{ taxData.ozu ? taxData.ozu: ' -' }}</span></div>
            <div>ОЗУ по иным документам: <span style='font-weight: bold;'>{{ lpo.ozu ? lpo.ozu: ' -' }}</span></div>
            <div v-if="criticalDensityParams.forest_use_protection_cat">
                {{ criticalDensityParams.forest_use_protection_cat }}
            </div>
            <div v-if="criticalDensityParams.water_protection_zone">
                {{ criticalDensityParams.water_protection_zone }}
            </div>
        </div>

        <div class="grid select-value-block">
            <div :class="{ 'not-match': !isMatch(values['critical_density']) }">
                <span class="select-title">Критическая полнота</span>
                <custom-p-select v-model="values['critical_density'].value" :options="info_critical_density" :disabled="!actLpoIsDraft" />
            </div>

            <p-button class="min-allowable-recall-val-btn" label='Минимальные допустимые значения полноты' @click="criticalParamsTableIsOpen = true" />
            <p-dialog header="МИНИМАЛЬНЫЕ ДОПУСТИМЫЕ ЗНАЧЕНИЯ ПОЛНОТЫ, ДО КОТОРЫХ НАЗНАЧАЮТСЯ ВЫБОРОЧНЫЕ САНИТАРНЫЕ РУБКИ" modal dismissableMask :visible.sync="criticalParamsTableIsOpen">
                <criticalDensityParamsTable />
            </p-dialog>
        </div>

        <div class="events-sub-title" style="margin-top: 50px;">
            Назначение СОМ
        </div>
        <div class="grid col-2 select-value-block" style="margin-top: 10px !important;">
            <div :class="{ 'not-match': !isMatch(values['is_only_dead_felling']) }">
                <custom-p-checkbox v-model="values['is_only_dead_felling'].value" label="В рубку назначаются только погибшие деревья" :disabled="!actLpoIsDraft" />
            </div>
        </div>

        <div class="grid col-2 select-value-block" style="margin-top: 10px !important;">
            <FellingDescriptions :isOnlyDeadFelling="values['is_only_dead_felling'].value" />
        </div>

        <div class="grid select-value-block">
            <div :class="{ 'not-match': !isMatch(values['is_more_double_loss']) }">
                <custom-p-checkbox v-model="values['is_more_double_loss'].value" label="объем пат. отпада в 2 и более раз превышает объем ест. отпада" :disabled="!actLpoIsDraft" />
            </div>

            <div :class="{ 'not-match': !isMatch(values['is_dead_seed_trees']) }">
                <custom-p-checkbox v-model="values['is_dead_seed_trees'].value" label="наличие погибших семенников" :disabled="!actLpoIsDraft" />
            </div>
        </div>

        <div class="events-sub-title" style="margin-top: 50px;">
            Санитарно-оздоровительные мероприятия, вычисленные по данным ЛПО
        </div>
        <p-message v-if="!lpo.age_group" severity="warn" :closable="false">
            Не указана группа возраста (вкладка Участок)
        </p-message>
        <div class="grid select-value-block" style="margin-top: 10px;">
            <InspectionMzlSom />
            <div :class="{ 'not-match': !isMatch(values['mzl_period_to']) }">
                <span class="select-title">Рекомендуемый срок проведения</span>
                <input type="date" class="custom-input" v-model="values['mzl_period_to'].value" :disabled="!actLpoIsDraft" />
            </div>
        </div>

        <div class="events-sub-title" style="margin-top: 50px;">
            Профилактические мероприятия
        </div>
        <div class="grid select-value-block" style="margin-top: 10px;">
            <div :class="{ 'not-match': notMatchingProfList }">
                <span class="select-title">Вид мероприятия</span>
                <custom-p-select v-model="valueProfList" :options="info_mzl_prof" multiple :disabled="!actLpoIsDraft" />
            </div>

            <div :class="{ 'not-match': !isMatch(values['mzl_period_from']) }">
                <span class="select-title">Рекомендуемый срок проведения</span>
                <input type="date" class="custom-input" v-model="values['mzl_period_from'].value" :disabled="!actLpoIsDraft" />
            </div>
        </div>

        <!-- Ulyana was here 03.11.2022 -->
          <div class="grid col-2 select-value-block">
            <div :class="{ 'not-match': notMatchingAgitList }">
                <span class="select-title">РЕКОМЕНДАЦИИ по проведению мероприятий, не относящихся к
                    мероприятиям по предупреждению распространения вредных
                    организмов</span>
                <custom-p-select v-model="valueAgitList" :options="info_mzl_agit" multiple :disabled="!actLpoIsDraft" />
            </div>
        </div>
        

        <div class="grid select-value-block disabledDiv">
            <div :class="{ 'not-match': notMatchingNeighbor }">
                <span class="select-title">Мероприятия для смежных насаждений</span>
                <custom-p-select v-model="valueNeighbor" :options="info_mzl_neighbor" :disabled="!actLpoIsDraft" />
            </div>
        </div>
        

        <div class="values-btn-row not-match-block" v-if="
          notMatchingValues.length ||
            notMatchingAgitList ||
            notMatchingProfList ||
            notMatchingNeighbor
        ">
            <div>
                <button @click="cancel">Отмена</button>
                <button @click="save">Сохранить</button>
            </div>
        </div>
    </template>
</div>
</template>

<script>
import {
    mapState,
    mapActions,
    mapGetters
} from "vuex";
import InspectionMzlSom from "./CurrentLpo__mzlSom";
import criticalDensityParamsTable from "./CurrentLpo__criticalDensityParamsTable.vue";
import FellingDescriptions from "./fellingDescriptions/FellingDescriptions.vue";

export default {
    name: "InspectionMzl",

    components: {
        InspectionMzlSom,
        criticalDensityParamsTable,
        FellingDescriptions,
    },

    data() {
        return {
            criticalParamsTableIsOpen: false,

            valueAgitList: [],
            valueProfList: [],

            valueNeighbor: null,

            values: {
                // neighbor_mzl: {
                // 	field: 'neighbor_mzl_id',
                // 	inputType: 'select',
                // 	value: null,
                // 	catalog: 'info_mzl_neighbor',
                // },

                is_only_dead_felling: {
                    field: "is_only_dead_felling",
                    inputType: "checkbox",
                    value: false,
                },

                is_more_double_loss: {
                    field: "is_more_double_loss",
                    inputType: "checkbox",
                    value: false,
                },

                is_dead_seed_trees: {
                    field: "is_dead_seed_trees",
                    inputType: "checkbox",
                    value: false,
                },

                critical_density: {
                    field: "critical_density_id",
                    inputType: "select",
                    value: null,
                    catalog: "info_critical_density",
                },

                mzl_period_to: {
                    field: "mzl_period_to",
                    inputType: "date",
                    value: null,
                },

                mzl_period_from: {
                    field: "mzl_period_from",
                    inputType: "input",
                    value: null,
                },
            },

            catalogsAreLoading: false,
        };
    },
    computed: {
        actLpoIsDraft() {
            return this.$store.getters["lpoData/actLpoIsDraft"];
        },

        notMatchingValues() {
            const result = [];

            for (const value_name in this.values) {
                if (!this.isMatch(this.values[value_name])) {
                    result.push(value_name);
                }
            }

            return result;
        },

        notMatchingNeighbor() {
            if (!this.valueNeighbor && !this.neighborMzl) {
                return false;
            } else if (this.valueNeighbor && this.neighborMzl) {
                if (this.valueNeighbor.id !== this.neighborMzl.mzl_id) {
                    return true;
                }
            } else if (!this.valueNeighbor && this.neighborMzl) {
                return true;
            } else if (this.valueNeighbor && !this.neighborMzl) {
                if (!this.valueNeighbor.id) {
                    return false;
                }
                return true;
            }

            return false;
        },

        notMatchingAgitList() {
            if (this.valueAgitList.length !== this.agitMzlList.length) {
                return true;
            }

            for (const mzl of this.agitMzlList) {
                if (!this.valueAgitList.find((m) => m.id === mzl.mzl_id)) {
                    return true;
                }
            }

            return false;
        },

        notMatchingProfList() {
            if (this.valueProfList.length !== this.profMzlList.length) {
                return true;
            }

            for (const mzl of this.profMzlList) {
                if (!this.valueProfList.find((m) => m.id === mzl.mzl_id)) {
                    return true;
                }
            }

            return false;
        },

        ...mapState("selectedLpo", {
            lpo: (state) => state["lpo"],
            neighborMzl: (state) => state["neighborMzl"],
            agitMzlList: (state) => state["agitMzlList"],
            profMzlList: (state) => state["profMzlList"],
            mzlNoNeedLoading: (state) => state["mzlNoNeedLoading"],
            criticalDensityParams: (state) => state.mzl["criticalDensityParams"],
        }),

        ...mapState({
            info_critical_density: (state) => state.catalogs["info_critical_density"],
            info_mzl_agit: (state) => state.catalogs["info_mzl_agit"],
            info_mzl_prof: (state) => state.catalogs["info_mzl_prof"],
            info_mzl_neighbor: (state) => state.catalogs["info_mzl_neighbor"],
        }),
        ...mapGetters('selectedLpo', [
            'taxData'
        ])
    },
    watch: {
        agitMzlList() {
            this.resetAgitList();
        },
        profMzlList() {
            this.resetProfList();
        },
    },
    methods: {
        save() {
            if (this.notMatchingNeighbor) {
                // console.log(this.valueNeighbor)

                if (this.valueNeighbor === null) {
                    this.valueNeighbor = {
                        id: null,
                        name: null,
                    };
                }

                this.saveNeighborMzl(this.valueNeighbor).then((res) => {
                    this.updateNeighborMzl();
                });
            }

            if (this.notMatchingAgitList) {
                this.saveAgitMzlList(this.valueAgitList).then((res) => {
                    this.updateAgitMzlList();
                });
            }

            if (this.notMatchingProfList) {
                if (!this.valueProfList.length) {
                    this.values.mzl_period_from.value = null;
                }

                this.saveProfMzlList(this.valueProfList).then((res) => {
                    this.updateProfMzlList();
                });
            }

            if (this.notMatchingValues.length) {
                // console.log('lalal');
                const valueList = [];

                for (const value_name of this.notMatchingValues) {
                    const inputTypeIsSelect = this.values[value_name].inputType === "select";
                    const inputTypeIsDate = this.values[value_name].inputType === 'date';
                    if (inputTypeIsDate) {
                        if (this.values[value_name].value == '') {
                            this.values[value_name].value = null
                        }
                    }
                    const temp = {
                        field: this.values[value_name].field,
                        value: inputTypeIsSelect && this.values[value_name].value ?
                            this.values[value_name].value.id : this.values[value_name].value,
                    };
                    valueList.push(temp);
                }

                this.saveLpoValue(valueList).then((res) => {
                    return this.updateLpo();
                });
            }
        },
        cancel() {
            this.resetValues();
        },

        resetValues() {
            for (let value_name in this.values) {
                const value = this.values[value_name];

                if (value.inputType === "checkbox") {
                    value.value = this.lpo[value.field] === "t";
                } else if (value.inputType === "select") {
                    const temp = this[value.catalog].find((item) => {
                        return item.id === this.lpo[value.field];
                    });
                    value.value = temp ? temp : null;
                } else if (value.inputType === "input" || value.inputType === "date") {
                    value.value = this.lpo[value.field];
                }
            }

            this.resetNeighbor();
            this.resetAgitList();
            this.resetProfList();
        },

        resetNeighbor() {
            if (!this.neighborMzl) {
                this.valueNeighbor = null;
            } else {
                this.valueNeighbor = {
                    id: this.lpo.neighbor_mzl_id,
                    name: this.lpo.neighbor_mzl,
                };
            }
        },

        resetAgitList() {
            this.valueAgitList = [];
            for (const mzl of this.agitMzlList) {
                const temp = {
                    id: mzl.mzl_id,
                    name: mzl.name,
                };

                this.valueAgitList.push(temp);
            }
        },

        resetProfList() {
            this.valueProfList = [];
            for (const mzl of this.profMzlList) {
                const temp = {
                    id: mzl.mzl_id,
                    name: mzl.name,
                };

                this.valueProfList.push(temp);
            }
        },

        isMatch(value) {
            if (this.catalogsAreLoading) {
                return true;
            }

            if (value.inputType === "input" || value.inputType == "date") {
                return value.value === this.lpo[value.field];
            } else if (value.inputType === "select") {
                if (!value.value) {
                    return this.lpo[value.field] === null;
                } else {
                    return value.value.id === this.lpo[value.field];
                }
            } else if (value.inputType === "checkbox") {
                return value.value === (this.lpo[value.field] === "t");
            }

            return false;
        },

        ...mapActions("selectedLpo", [
            "saveNeighborMzl",
            "updateNeighborMzl",
            "saveAgitMzlList",
            "updateAgitMzlList",
            "saveProfMzlList",
            "updateProfMzlList",
            "getCriticalDensityParams",
            "saveLpoValue",
            "updateLpo",
        ])
    },
    created() {
        this.getCriticalDensityParams();

        const catalogs = [
            "info_critical_density",
            "info_mzl_agit",
            "info_mzl_prof",
            "info_mzl_neighbor",
        ];

        this.catalogsAreLoading = true;
        this.$store.dispatch("loadCatalogs", catalogs).then((res) => {
            this.catalogsAreLoading = false;
            this.resetValues();

            if (!this.valueNeighbor) {
                const mzl = this.info_mzl_neighbor.find((item) => item.id === null);
                this.valueNeighbor = mzl ? mzl : null;
            }
        });
    },
};
</script>

<style scoped src="@/style/grid.css"></style>
<style scoped src="@/style/input.css"></style>
<style scoped src="@/style/button.css"></style>

<style scoped>
.events-sub-title {
    font-size: 16px;
    font-style: italic;
    font-weight: bold;
    margin-bottom: 10px;
}

.min-allowable-recall-val-btn {
    height: 33px;
    font-size: 13px;
    padding-bottom: 4px;
    margin-top: 23px;
}

.critical-density-params>div {
    font-style: italic;
    font-size: 1rem;
    margin-bottom: 0.3rem;
}
</style>

<style scoped>
.grid.col-2 {
    grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
    padding: 0;
}

.flex {
    display: flex;
}

.flex-item {
    flex: 1;
}

.agit-prof-block {
    margin-top: 10px;
}

.not-match {
    background-color: orange;
}

.select-value-block {
    margin-top: 34px;
}

.disabledDiv {
    pointer-events: none;
    opacity: 0.4;
}

.select-title {
    font-weight: bold;
    display: inline-block;
    margin-bottom: 6px;
}
</style>
